import {
  Box,
  Card, Checkbox,
  Table, TableBody, TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import React from 'react';

const List = ({ quotes, selectedList, migrated, handleChange }) => {

  const getColor = (quote) => {
    const quoteMigrated = migrated.filter(obj => obj.id === quote.id);

    if (quoteMigrated.length > 0) {
      return "rgba(255,213,0,0.57)";
    }

    return selectedList.filter(val => val === quote.id).length > 0 ? "rgba(76,0,255,0.07)" : "transparent"
  }

  return (
    <Card>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>ID</TableCell>
              <TableCell>Trecho</TableCell>
              <TableCell>ID do usuário</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {quotes.map(quote => (
              <TableRow style={{backgroundColor: getColor(quote)}} key={quote.id}>
                <TableCell width={50}>
                  <Checkbox checked={selectedList.filter(val => val === quote.id).length > 0} onChange={(e) => {
                    handleChange(quote.id)
                  }} />
                </TableCell>
                <TableCell width={50}>
                  {quote.id}
                </TableCell>
                <TableCell>
                  <Box sx={{ maxHeight: '60px', overflow: 'hidden' }}>
                    {quote.content}
                  </Box>
                </TableCell>
                <TableCell width={140}>
                  {quote.user.id}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default List;
